import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { CurrentUser, getAuthErrorStatus, getCurrentUser } from "../api/auth";

export const currentUserKeys = {
  all: ["current-user"] as const,
};

/** `GET /auth/me` — the signed-in user's Bagel record. */
export const useCurrentUserQuery = () => {
  const auth0 = useAuth0();

  return useQuery({
    queryKey: currentUserKeys.all,
    queryFn: getCurrentUser,
    enabled: auth0.isAuthenticated,
    staleTime: 5 * 60 * 1000,
    retry: (failureCount, error) => {
      // 401/404 are terminal: the token carries no identity, or the user is not
      // provisioned. Retrying either just delays the unauthorized screen.
      const status = getAuthErrorStatus(error);
      if (status === 401 || status === 404) return false;
      return failureCount < 2;
    },
  });
};

export const useCurrentUser = (): CurrentUser | null =>
  useCurrentUserQuery().data ?? null;
